import React, { MutableRefObject } from 'react';
import { SwipeableHandlers } from 'react-swipeable';

import VideoJS from './VideoJS';
import { VideoPlayerStyles } from './styles';
import { StaticVideo } from '../../types/items';
import { VideoMeta } from './types';
import { isMobileOnly } from 'react-device-detect';

type Props = {
  src: string;
  isStream?: boolean;
  swipeable?: SwipeableHandlers;
  media?: 'audio' | 'video';
  nativeControls?: boolean;
  poster?: string;
  refPreviewContent: MutableRefObject<HTMLDivElement | null>;
  staticVideo?: StaticVideo;
  videoMeta?: VideoMeta;
  type?: string;
  duration?: number;
  onPlay?: () => void;
  onPause?: () => void;
  onResizePlayer?: (props: { height: string; width: string }) => void;
};

const Player = ({
  src,
  duration,
  isStream = false,
  swipeable,
  media = 'video',
  nativeControls = false,
  poster,
  refPreviewContent,
  staticVideo,
  videoMeta,
  type,
  onPlay,
  onPause,
  onResizePlayer,
}: Props) => {
  const classes = VideoPlayerStyles();

  return (
    <div className={isMobileOnly ? classes.rootMobile : classes.root} {...swipeable}>
      <VideoJS
        src={src}
        duration={duration}
        media={media}
        nativeControls={nativeControls}
        poster={poster}
        refPreviewContent={refPreviewContent}
        staticVideo={staticVideo}
        videoMeta={videoMeta}
        type={type}
        onPause={onPause}
        onPlay={onPlay}
        onResizePlayer={onResizePlayer}
      />
    </div>
  );
};

export default Player;
